import React from "react";
import PlayerWindow from "./PlayerWindow";

const VideoPlayer = ({ videoSrc, onClose }) => {
    return (
        <PlayerWindow title="Video Player" onClose={onClose}>
            <video autoPlay controls style={{ width: "100%", maxHeight: "300px" }}>
                <source src={videoSrc} type="video/mp4" />
                <source src={videoSrc} type="video/mov" />
                Your browser does not support the video element.
            </video>
        </PlayerWindow>
    );
};

export default VideoPlayer;